import React from 'react'
import { useAppSelector } from 'src/hooks'
import { selectUser } from 'src/redux'
import useWebSocket, { ReadyState } from 'react-use-websocket'
import { useEffect } from 'react'
import { useToastContext } from 'src/contexts/Toast.context'
import { Box, Typography } from '@mui/material'

const useWebsocketNotification = () => {
  const { serverUrl: serverPath, userName } = useAppSelector(selectUser)
  const { warning } = useToastContext()
  const WS_URL =
    'wss://' +
    serverPath +
    '/sialdPMS/secure/logged/panel/layout/mainLayout?' +
    userName

  const { sendJsonMessage, lastJsonMessage, readyState } = useWebSocket<any>(
    WS_URL,
    {
      share: false,
      shouldReconnect: () => true
    }
  )

  useEffect(() => {}, [])

  useEffect(() => {
    const messageTitle = lastJsonMessage?.title
    const messageBody = lastJsonMessage?.message
    if (messageTitle || messageBody) {
      warning({
        message: (
          <Box>
            {messageTitle && (
              <Typography fontWeight={600}>{messageTitle}</Typography>
            )}
            <Typography>{messageBody}</Typography>
          </Box>
        ),
        options: {
          autoClose: false
        }
      })
    }
  }, [lastJsonMessage])

  return {}
}

export default useWebsocketNotification
